import { ToggleChipOption } from 'src/routes/onboarding/setup/components/ToggleChipGroup';

export const COMPANY_AGE_OPTIONS: ToggleChipOption[] = [
  { label: 'New business', value: 'new_business' },
  { label: 'Under a year', value: 'under_a_year' },
  { label: '1 - 2 years', value: '1_2_years' },
  { label: '3 - 5 years', value: '3_5_years' },
  { label: '6 - 10 years', value: '6_10_years' },
  { label: '11+ years', value: '11+_years' },
];

export const COMPANY_SIZE_OPTIONS: ToggleChipOption[] = [
  {
    label: 'Just me',
    value: '1',
  },
  {
    label: '2 - 5',
    value: '5',
  },
  {
    label: '6 - 10',
    value: '10',
  },
  {
    label: '11 - 50',
    value: '50',
  },
  {
    label: '51 - 100',
    value: '100',
  },
  {
    // the label and value don't match here because the value is used for analytics
    // and we wanted to keep it stable even though the display label is different
    label: '101+',
    value: '100+',
  },
];

/**
 * the following constants are for fields that use material UI's Autocomplete component
 *
 * these are structured more verbosely because it's much easier to work with arrays of strings
 * than arrays of objects for Autocomplete's options prop
 */

export const INDUSTRY_OPTIONS = [
  'accounting_and_bookkeeping',
  'construction',
  'consulting',
  'design',
  'ecommerce',
  'education',
  'engineering',
  'entertainment',
  'finance',
  'healthcare',
  'insurance',
  'legal',
  'logistics_and_transportation',
  'manufacturing',
  'marketing',
  'nonprofit',
  'real_estate',
  'recruiting_and_staffing',
  'technology',
  'travel_and_tourism',
] as const;

export type IndustryOptionType = (typeof INDUSTRY_OPTIONS)[number];

export const INDUSTRY_LABELS: Record<IndustryOptionType, string> = {
  accounting_and_bookkeeping: 'Accounting and bookkeeping',
  construction: 'Construction',
  consulting: 'Consulting',
  design: 'Design',
  ecommerce: 'Ecommerce',
  education: 'Education',
  engineering: 'Engineering',
  entertainment: 'Entertainment',
  finance: 'Finance',
  healthcare: 'Healthcare',
  insurance: 'Insurance',
  legal: 'Legal',
  logistics_and_transportation: 'Logistics and transportation',
  manufacturing: 'Manufacturing',
  marketing: 'Marketing',
  nonprofit: 'Nonprofit',
  real_estate: 'Real estate',
  recruiting_and_staffing: 'Recruiting and staffing',
  technology: 'Technology',
  travel_and_tourism: 'Travel and tourism',
};

export const CLIENT_SOURCE_OPTIONS = [
  'airtable',
  'email',
  'google_sheets',
  'honeybook',
  'hubspot',
  'ignition',
  'quickbooks_online',
  'salesforce',
  'service_provider_pro',
  'shopify',
  'stripe',
  'suitedash',
  'xero',
] as const;

export const CLIENT_SOURCE_LABELS: Record<
  (typeof CLIENT_SOURCE_OPTIONS)[number],
  string
> = {
  airtable: 'Airtable',
  email: 'Email',
  google_sheets: 'Google Sheets',
  honeybook: 'HoneyBook',
  hubspot: 'HubSpot',
  ignition: 'Ignition',
  quickbooks_online: 'QuickBooks Online',
  salesforce: 'Salesforce',
  service_provider_pro: 'Service Provider Pro (SPP)',
  shopify: 'Shopify',
  stripe: 'Stripe',
  suitedash: 'SuiteDash',
  xero: 'Xero',
};
